/*
request.js wrapped the axios library
It will do extra operations for all request
ex: add auth token, log request, etc.
After ajax finish, check error code automatically
*/
import qs from 'qs';
import axios from 'axios';
import checkSSO from '@/utils/js/checkSSO';

let appid = '';
// let token = '';

function addCustomHeader(config) {
  let option = Object.assign({}, config);
  if (!config) {
    option = {};
  }
  // TODO: correct header should add here
  if (!option.headers) {
    option.headers = {};
  }
  option.headers['X-Appid'] = appid;
  option.headers['X-Locale'] = localStorage.getItem('locale');
  option.headers['If-Modified-Since'] = '0';

  const token = localStorage.getItem('token');  // 这里！从localStorage中获取token
  if (token !== '' && token !== undefined && token !== null && token !== 'null') {
    option.headers.Authorization = `Bearer ${token}`;
  }
  // option.headers.Access_token = this.$cookie.get('access_token');
  return option;
}

function handleUnAuthenticated() {
  // this.$logout(true);
  const fullPath = this.$route.fullPath;
  // 自定义登录页路径，用于sso
  const SSOEnable = process.env.SSO_ENABLE;
  const customLoginPage = `/customSso/login?redirect=${encodeURIComponent(fullPath)}`;
  // sso开关的配置在(config/dev.env.js, config/prod.env.js, config/test.env.js)环境配置中,
  // 注意开关状态要与后端服务的开关状态保持一致，如业务需要打开, 则需要同步打开,
  // 如配置了sso开关则跳转到定制化登录页，否则跳转标准化的登录页
  window.location = SSOEnable ? customLoginPage : `/login.html?invalid=1&redirect=${encodeURIComponent(fullPath)}`;
}

function checkAjaxError(context, error) {
  let status;
  if (error.response) {
    status = error.response.status;
  }
  if (status === 401) {
    handleUnAuthenticated.bind(context)();
  }

  // handle only 500 series status code in plugin
  // 400 series may has different meanings for different modules
  if (status >= 500) {
    // TODO add union notification method
    // context.$notify({
    //   text: `${context.$t('general.error_code')} ${status}`,
    //   type: 'fail',
    // });
  }
  throw error;
}

function ajax(config) {
  const that = this;
  return checkSSO().then(() => {
    const getConfigWithCustomHeader = addCustomHeader.bind(that);
    const header = getConfigWithCustomHeader(config);
    let axiosInstance = axios.create();
    if (config.responseType === 'blob') {
      axiosInstance = axios.create({ responseType: 'blob' });
    }
    return axiosInstance(header).catch((err) => {
      checkAjaxError.bind(this)(that, err);
    });
  });
}

function customType(url, type, data, config) {
  let option = Object.assign({}, config);
  if (!config) {
    option = {};
  }
  if (type === 'get') {
    option.params = data;
    option.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat' });
  } else {
    option.data = data;
  }
  option.method = type;
  option.url = url;
  return this.$reqAjax(option);
}

function get(url, config) {
  let option = Object.assign({}, config);
  if (!config) {
    option = {};
  }
  option.method = 'get';
  option.url = url;
  return this.$reqAjax(option);
}

function getBlob(url, config) {
  let option = Object.assign({}, config);
  if (!config) {
    option = {};
  }
  option.method = 'get';
  option.url = url;
  option.responseType = 'blob';
  return this.$reqAjax(option);
}

function postBlob(url, data, config) {
  let option = Object.assign({}, config);
  if (!config) {
    option = {};
  }
  option.method = 'post';
  option.url = url;
  option.responseType = 'blob';
  option.data = data;
  return this.$reqAjax(option);
}

function put(url, data, config) {
  return this.$reqCustom(url, 'put', data, config);
}

function post(url, data, config) {
  return this.$reqCustom(url, 'post', data, config);
}

function postForm(url, data, config) {
  const localConfig = { ...config };
  if (localConfig.headers === undefined) {
    localConfig.headers = {};
  }
  localConfig.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  const localData = qs.stringify(data);
  return this.$reqCustom(url, 'post', localData, localConfig);
}

function putForm(url, data, config) {
  const localConfig = { ...config };
  if (localConfig.headers === undefined) {
    localConfig.headers = {};
  }
  localConfig.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  const localData = qs.stringify(data);
  return this.$reqCustom(url, 'put', localData, localConfig);
}

function patch(url, data, config) {
  return this.$reqCustom(url, 'patch', data, config);
}

function patchForm(url, data, config) {
  const localConfig = { ...config };
  if (localConfig.headers === undefined) {
    localConfig.headers = {};
  }
  localConfig.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  const localData = qs.stringify(data);
  return this.$reqCustom(url, 'patch', localData, localConfig);
}

function deleteReq(url, config, params = {}) {
  return this.$reqCustom(url, 'delete', params, config);
}

function deleteDataReq(url, data, config) {
  return this.$reqCustom(url, 'delete', data, config);
}

function getParam(url, data, config) {
  return this.$reqCustom(url, 'get', data, config);
}

function checkExistedFunction(ret, name) {
  if (Object.hasOwnProperty.call(ret, name)) {
    console.warn(`Function: ${name} existed`);
  }
}

const MyPlugin = {
  install(Vue) {
    Vue.prototype.$reqGet = get;
    Vue.prototype.$reqGetParam = getParam;
    Vue.prototype.$reqGetBlob = getBlob;
    Vue.prototype.$reqPostBlob = postBlob;
    Vue.prototype.$reqCustom = customType;
    Vue.prototype.$reqPost = post;
    Vue.prototype.$reqPostForm = postForm;
    Vue.prototype.$reqPut = put;
    Vue.prototype.$reqPutForm = putForm;
    Vue.prototype.$reqDelete = deleteReq;
    Vue.prototype.$reqDeleteParam = deleteDataReq;
    Vue.prototype.$reqPatch = patch;
    Vue.prototype.$reqPatchForm = patchForm;
    Vue.prototype.$reqAjax = ajax;

    Vue.prototype.$setReqToken = function setUpToken(t) {
      localStorage.setItem('token', t);
    };
    Vue.prototype.$setReqAppid = function setupRobot(id) {
      appid = id;
    };
    // 挂载全局$api
    Vue.mixin({
      created() {
        const that = this;
        const functions = this.$options.api;
        if (functions !== undefined) {
          const ret = {};
          if (Array.isArray(functions)) {
            functions.forEach((mod) => {
              Object.getOwnPropertyNames(mod).forEach((key) => {
                checkExistedFunction(ret, key);
                if (typeof mod[key] === 'function') {
                  ret[key] = mod[key].bind(that);
                }
              });
            });
            this.$api = ret;
          } else {
            Object.getOwnPropertyNames(functions).forEach((key) => {
              checkExistedFunction(ret, key);
              if (typeof functions[key] === 'function') {
                ret[key] = functions[key].bind(that);
              }
            });
          }
          this.$api = ret;
        }
      },
    });
  },
};

export default MyPlugin;



// WEBPACK FOOTER //
// ./src/api/request.js